// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__29XN6","colMin":"styles_colMin__2xsDQ"};